import { FC } from 'react';

import { useIdCounter } from '../../hooks';
import { InputMessage } from '../input-message';

import { FieldSetMessage, FieldSetWrapper, Legend } from './field-set.styled';
import { IFieldSetProps } from './types';

/**
 * Groups several form fields and their labels together
 */
const FieldSet: FC<IFieldSetProps> = ({
  disabled,
  legend,
  children,
  errorMessage,
  hintMessage,
  messageId: messageIdProp,
  'data-testid': testId,
  className,
}) => {
  const defaultMessageId = useIdCounter('fieldset-message');
  const messageId = messageIdProp || defaultMessageId;

  return (
    <FieldSetWrapper disabled={disabled} className={className}>
      <Legend $disabled={disabled} $hasError={!!errorMessage}>
        {legend}
      </Legend>

      {children}

      <FieldSetMessage>
        <InputMessage
          disabled={disabled}
          id={messageId}
          hasError={!!errorMessage}
          data-testid={testId}
        >
          {errorMessage || hintMessage}
        </InputMessage>
      </FieldSetMessage>
    </FieldSetWrapper>
  );
};

export default FieldSet;
